var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMenuSelectedHome = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 39.54 39.44",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 19.77,
    y1: 39.22,
    x2: 19.77,
    y2: 0.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b9c49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#49a845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#83c03e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9aca3c"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M19.77,39.22C9.02,39.22,.27,30.47,.27,19.72S9.02,.22,19.77,.22s19.5,8.75,19.5,19.5-8.75,19.5-19.5,19.5Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.13,15.77l-2.73-1.81v-3.77c0-.41-.34-.75-.75-.75s-.75,.34-.75,.75v2.78l-3.79-2.52c-.62-.41-1.43-.41-2.05,0l-8.05,5.33c-.35,.23-.44,.69-.21,1.04,.14,.22,.38,.34,.63,.34,.14,0,.29-.04,.41-.12l8.05-5.33c.12-.08,.27-.08,.39,0l8.01,5.32c.34,.23,.81,.14,1.04-.21,.23-.34,.14-.81-.21-1.04Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.49,19.86c0-.54-.27-1.04-.73-1.33-7.04-4.46-7.42-4.56-7.54-4.59-.29-.08-.35-.1-7.83,4.59-.46,.29-.74,.79-.74,1.34l.02,7.22c0,.28,.22,.5,.5,.5h5.64c.28,0,.5-.22,.5-.5v-3.92c0-.18,.15-.33,.33-.33h2.78c.18,0,.33,.15,.33,.33v3.92c0,.28,.22,.5,.5,.5h5.75c.13,0,.26-.05,.35-.15s.15-.22,.15-.35l-.02-7.23Z",
    style: {
      fill: "#fff"
    }
  }));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuSelectedHome, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Menu_Selected_Home.35b12300.svg";
export { ForwardRef as ReactComponent };